module.exports = __webpack_public_path__ + "static/media/healthcare.6815568b.png";